export { default } from "../../../../parts/TrendIndicator";
